import { useDebounceState } from "@prismicio/editor-support/React"
import { map, union } from "@prismicio/editor-support/Set"
import type { FilterOption } from "@prismicio/editor-ui"
import { useState } from "react"

import { useEditorConfig } from "../../../EditorConfig"

export function useFilters(
  fixedCustomTypes?: Set<string>,
  fixedTags?: Set<string>
) {
  const config = useEditorConfig()

  const searchTerm = useDebounceState({
    initialState: ""
  })

  const [filteredTags, setFilteredTags] = useState<Set<FilterOption>>(new Set())

  const [filteredCustomTypes, setFilteredCustomTypes] = useState<
    Set<FilterOption>
  >(new Set())

  function getInitialLocale() {
    if (!config.searchDocuments || !config.localeId)
      return new Set<FilterOption>()

    return new Set([{ id: config.localeId, label: config.localeId }])
  }

  const [filteredLocales, setFilteredLocales] =
    useState<Set<FilterOption>>(getInitialLocale)

  const typesFilter = union(
    filteredCustomTypes,
    transformFixedFilters(fixedCustomTypes)
  )

  const tagsFilter = union(filteredTags, transformFixedFilters(fixedTags))

  return {
    searchTerm,
    filteredTags,
    setFilteredTags,
    filteredCustomTypes,
    setFilteredCustomTypes,
    filteredLocales,
    setFilteredLocales,
    typesFilter,
    tagsFilter
  }
}

export function transformFixedFilters(filters?: Set<string>) {
  if (!filters) return new Set<FilterOption>()

  return map(filters, (filter) => ({ id: filter, label: filter }))
}
